import { render, staticRenderFns } from "./ViewOrderPartDocument.vue?vue&type=template&id=3bc35c6c&scoped=true&"
import script from "./ViewOrderPartDocument.vue?vue&type=script&lang=js&"
export * from "./ViewOrderPartDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc35c6c",
  null
  
)

export default component.exports